export const MODE_TABLET = 'MODE_TABLET';
export const MODE_MOBILE = 'MODE_MOBILE';
export const MODE_PC = 'MODE_PC';
